/*! ATOMGYM cookie banner RGPD CNIL-compliant (vanilla, dormant tant que pas de pixels) */
(function(){
  "use strict";
  // ─── CONFIG ─────────────────────────────────────────────────────────
  // Tant qu'on a pas les pixels Tom, le banner est DÉSACTIVÉ par défaut.
  // Pour l'ACTIVER (quand Tom donne ses IDs) : changer ENABLED à true + remplir les IDs.
  var ENABLED = false;
  var CONSENT_KEY = "atomgym_consent_v1";
  var PIXEL_IDS = {
    metaPixel: "",          // ex: "1234567890"
    ga4: "",                // ex: "G-XXXXXXXX"
    googleAds: "",          // ex: "AW-XXXXXXXXX"
    tiktokPixel: "",        // ex: "CXXXXXXXXXXXXX"
    snapPixel: ""           // ex: "uuid-format"
  };

  if (!ENABLED) return;
  if (localStorage.getItem(CONSENT_KEY)) {
    if (localStorage.getItem(CONSENT_KEY) === "marketing") loadPixels();
    return;
  }

  // ─── BUILD BANNER ────────────────────────────────────────────────────
  function buildBanner() {
    var banner = document.createElement("div");
    banner.id = "cookie-banner";
    banner.setAttribute("role", "dialog");
    banner.setAttribute("aria-label", "Consentement aux cookies");
    banner.setAttribute("aria-live", "polite");
    banner.style.cssText = [
      "position:fixed",
      "bottom:1rem",
      "left:1rem",
      "right:1rem",
      "max-width:480px",
      "margin-left:auto",
      "margin-right:auto",
      "background:#0a0a0a",
      "color:#fff",
      "padding:1.25rem 1.4rem",
      "border-radius:8px",
      "box-shadow:0 12px 40px -10px rgba(0,0,0,.5)",
      "z-index:9999",
      "font-family:'DM Sans',system-ui,sans-serif",
      "font-size:.88rem",
      "line-height:1.5"
    ].join(";");

    banner.innerHTML = '' +
      '<p style="margin:0 0 .9rem;color:#fff">On utilise des cookies pour mesurer l\'audience et améliorer ton expérience. ' +
      '<a href="/policies/privacy" style="color:#fff;text-decoration:underline">En savoir plus</a>.</p>' +
      '<div style="display:flex;gap:.5rem;flex-wrap:wrap">' +
        '<button type="button" data-consent="marketing" style="flex:1;background:#fff;color:#000;border:0;padding:.7rem 1.2rem;font-weight:700;font-size:.78rem;letter-spacing:.12em;text-transform:uppercase;cursor:pointer;border-radius:3px;min-width:120px">Tout accepter</button>' +
        '<button type="button" data-consent="essential" style="flex:1;background:transparent;color:#fff;border:1px solid rgba(255,255,255,.4);padding:.7rem 1.2rem;font-weight:700;font-size:.78rem;letter-spacing:.12em;text-transform:uppercase;cursor:pointer;border-radius:3px;min-width:120px">Refuser</button>' +
      '</div>';

    banner.addEventListener("click", function(e){
      var btn = e.target.closest("[data-consent]");
      if (!btn) return;
      var choice = btn.dataset.consent;
      try { localStorage.setItem(CONSENT_KEY, choice); } catch(_){}
      banner.remove();
      if (choice === "marketing") loadPixels();
    });

    document.body.appendChild(banner);
  }

  // ─── LOAD PIXELS (only after consent) ────────────────────────────────
  function loadPixels(){
    // Meta Pixel
    if (PIXEL_IDS.metaPixel){
      !function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,document,'script','https://connect.facebook.net/en_US/fbevents.js');
      window.fbq('init', PIXEL_IDS.metaPixel);
      window.fbq('track', 'PageView');
    }
    // GA4
    if (PIXEL_IDS.ga4){
      var s = document.createElement('script');
      s.async = true;
      s.src = 'https://www.googletagmanager.com/gtag/js?id=' + PIXEL_IDS.ga4;
      document.head.appendChild(s);
      window.dataLayer = window.dataLayer || [];
      window.gtag = function(){ window.dataLayer.push(arguments); };
      window.gtag('js', new Date());
      window.gtag('config', PIXEL_IDS.ga4);
    }
    // Google Ads
    if (PIXEL_IDS.googleAds && window.gtag){
      window.gtag('config', PIXEL_IDS.googleAds);
    }
    // TikTok Pixel
    if (PIXEL_IDS.tiktokPixel){
      !function (w, d, t) {w.TiktokAnalyticsObject=t;var ttq=w[t]=w[t]||[];ttq.methods=["page","track","identify","instances","debug","on","off","once","ready","alias","group","enableCookie","disableCookie"],ttq.setAndDefer=function(t,e){t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}};for(var i=0;i<ttq.methods.length;i++)ttq.setAndDefer(ttq,ttq.methods[i]);ttq.instance=function(t){for(var e=ttq._i[t]||[],n=0;n<ttq.methods.length;n++)ttq.setAndDefer(e,ttq.methods[n]);return e},ttq.load=function(e,n){var i="https://analytics.tiktok.com/i18n/pixel/events.js";ttq._i=ttq._i||{},ttq._i[e]=[],ttq._i[e]._u=i,ttq._t=ttq._t||{},ttq._t[e]=+new Date,ttq._o=ttq._o||{},ttq._o[e]=n||{};var o=document.createElement("script");o.type="text/javascript",o.async=!0,o.src=i+"?sdkid="+e+"&lib="+t;var a=document.getElementsByTagName("script")[0];a.parentNode.insertBefore(o,a)};ttq.load(PIXEL_IDS.tiktokPixel);ttq.page()}(window, document, 'ttq');
    }
    // Snap Pixel
    if (PIXEL_IDS.snapPixel){
      (function(e,t,n){if(e.snaptr)return;var a=e.snaptr=function(){a.handleRequest?a.handleRequest.apply(a,arguments):a.queue.push(arguments)};a.queue=[];var s='script';r=t.createElement(s);r.async=!0;r.src=n;var u=t.getElementsByTagName(s)[0];u.parentNode.insertBefore(r,u)})(window,document,'https://sc-static.net/scevent.min.js');
      window.snaptr('init', PIXEL_IDS.snapPixel);
      window.snaptr('track', 'PAGE_VIEW');
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", buildBanner);
  } else {
    buildBanner();
  }
})();
